<div class="adult-courses">
  <lx-course-selector-field
    (selectedValueChange)="selectedCourseChange.emit($event)"
    [disabled]="!!!courseDetails.selectedSchoolLocation"
    [selectedValue]="courseDetails.selectedCourse"
  ></lx-course-selector-field>
  <lx-duration-selector-field
    (selectedValueChange)="selectedDurationChange.emit($event)"
    [disabled]="!!!courseDetails.selectedCourse"
    [selectedValue]="courseDetails.selectedDuration"
  ></lx-duration-selector-field>
  <ng-container [ngSwitch]="startDateSelectorType">
    <lx-fixed-date-selector-field
      (selectedValueChange)="selectedStartDateChange.emit($event?.date)"
      *ngSwitchCase="'fixedDates'"
      [automaticOpen]="automaticOpenDatePanel$ | async"
      [disabled]="!!!courseDetails.selectedDuration"
      [fixedDates]="schoolStartDates"
      [selectedValue]="{ date: courseDetails?.selectedStartDate }"
      i18n-label
      i18n-title
      label="Start date"
      title="Select a start date"
    >
      <lx-dates [startDate]="selectedStartDate()" [endDate]="selectedEndDate()" [emptyMsg]="emptySelectionMsg"></lx-dates>
    </lx-fixed-date-selector-field>
    <lx-flexible-start-date-selector-field
      (selectedValueChange)="selectedStartDateChange.emit($event)"
      *ngSwitchCase="'flexibleDates'"
      [automaticOpen]="automaticOpenDatePanel$ | async"
      (yearChanged)="setChristmasClosureDisclaimer($event)"
      [disabled]="!!!courseDetails.selectedDuration"
      [selectedValue]="courseDetails.selectedStartDate"
      [selectedStartDate]="courseDetails.selectedStartDate"
      [selectedEndDate]="courseDetails.selectedEndDate"
      [disclaimer]="disclaimer$ | async"
      [calendarConfig]="calendarConfig"
    >
    </lx-flexible-start-date-selector-field>
  </ng-container>
</div>
